var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.672 204.533C400.911 174.824 388.001 147.118 374.494 128.117C342.029 82.4484 266.544 62.3509 214.402 81.4812C169.968 97.7845 154.407 147.072 115.591 170.677C79.8813 192.393 47.4756 210.096 34.9885 251.487C8.60566 338.934 112.933 408.648 190.896 386.468C215.501 379.468 236.3 364.74 262.548 364.649C315.792 364.464 334.547 371.761 377.621 343.029C420.06 314.718 422.261 256.555 408.672 204.533Z",
    fill: "#EEE9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5194 373.681C72.5194 373.681 61.538 356.293 41.644 346.012C21.7499 335.73 13.2703 325.58 23.5902 326.191C36.1111 326.922 64.4848 336.832 77.3787 371.703C82.9475 386.754 72.5074 373.681 72.5074 373.681",
    fill: "#F4FCBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5194 373.681C72.5194 373.681 61.538 356.293 41.644 346.012C21.7499 335.73 13.2703 325.58 23.5902 326.191C36.1111 326.922 64.4848 336.832 77.3787 371.703C82.9475 386.754 72.5074 373.681 72.5074 373.681",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8566 369.127C71.8566 369.127 61.9096 349.306 43.1221 339.756",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4749 385.7C84.4749 385.7 78.1964 368.216 81.9852 348.384C85.7619 328.552 83.2601 316.88 77.9318 324.537C71.4608 333.812 62.6805 359.432 80.3614 388.048C87.9871 400.391 84.487 385.712 84.487 385.712",
    fill: "#F4FCBE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4749 385.7C84.4749 385.7 78.1964 368.216 81.9852 348.384C85.7619 328.552 83.2601 316.88 77.9318 324.537C71.4608 333.812 62.6805 359.432 80.3614 388.048C87.9871 400.391 84.487 385.712 84.487 385.712",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6135 382.692C81.6135 382.692 73.0256 364.573 76.7182 345.939",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3255 364.933C73.3255 364.933 67.047 347.449 70.8358 327.617C74.6125 307.785 72.1107 296.113 66.7824 303.771C60.3114 313.046 51.5311 338.666 69.212 367.282C76.8377 379.624 73.3376 364.945 73.3376 364.945",
    fill: "#F4FCBE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3255 364.933C73.3255 364.933 67.047 347.449 70.8358 327.617C74.6125 307.785 72.1107 296.113 66.7824 303.771C60.3114 313.046 51.5311 338.666 69.212 367.282C76.8377 379.624 73.3376 364.945 73.3376 364.945",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8581 369.127C71.8581 369.127 61.875 343.807 65.5675 325.173",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M361.891 373.337C361.891 373.337 372.872 355.949 392.767 345.668C412.661 335.386 421.14 325.236 410.82 325.848C398.287 326.579 369.926 336.489 357.032 371.36C351.463 386.411 361.903 373.337 361.903 373.337",
    fill: "#F4FCBE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.891 373.337C361.891 373.337 372.872 355.949 392.767 345.668C412.661 335.386 421.14 325.236 410.82 325.848C398.287 326.579 369.926 336.489 357.032 371.36C351.463 386.411 361.903 373.337 361.903 373.337",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M362.554 368.796C362.554 368.796 372.501 348.975 391.288 339.425",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M349.923 385.356C349.923 385.356 356.202 367.872 352.413 348.04C348.636 328.208 351.138 316.536 356.466 324.194C362.937 333.469 371.718 359.089 354.037 387.705C346.411 400.047 349.911 385.368 349.911 385.368",
    fill: "#F4FCBE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M349.923 385.356C349.923 385.356 356.202 367.872 352.413 348.04C348.636 328.208 351.138 316.536 356.466 324.194C362.937 333.469 371.718 359.089 354.037 387.705C346.411 400.047 349.911 385.368 349.911 385.368",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M352.799 382.36C352.799 382.36 361.387 364.241 357.694 345.607",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.073 364.589C361.073 364.589 367.351 347.106 363.562 327.274C359.786 307.441 362.287 295.77 367.616 303.427C374.087 312.702 382.867 338.322 365.186 366.938C357.56 379.281 361.061 364.601 361.061 364.601",
    fill: "#F4FCBE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M361.073 364.589C361.073 364.589 367.351 347.106 363.562 327.274C359.786 307.441 362.287 295.77 367.616 303.427C374.087 312.702 382.867 338.322 365.186 366.938C357.56 379.281 361.061 364.601 361.061 364.601",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M362.552 368.795C362.552 368.795 372.535 343.475 368.842 324.841",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193.227 263.315H77.3613V327.907H193.227V263.315Z",
    fill: "#CBCBCB",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M193.226 263.315H160.377V327.907H193.226V263.315Z",
    fill: "#303826",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.625 182.335H162.76V391.946H278.625V182.335Z",
    fill: "#CBCBCB",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M278.931 182.335H246.082V391.946H278.931V182.335Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.227 327.527H77.3613V392.119H193.227V327.527Z",
    fill: "#CBCBCB",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M286.524 294.087L226.222 214.869H193.206V235.524L148.627 294.087H286.524Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M193.206 214.869L132.904 294.087H253.508L193.206 214.869Z",
    fill: "#BCA3F9",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M356.443 294.483H240.577V392.119H356.443V294.483Z",
    fill: "#E7E7E7",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M356.443 294.483H312.304V392.119H356.443V294.483Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M234.818 294.483H118.952V392.119H234.818V294.483Z",
    fill: "#E7E7E7",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M234.818 294.483H190.679V392.119H234.818V294.483Z",
    fill: "white",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M431.498 393.127H24.0254V392.158H431.498V393.127Z",
    fill: "#303826",
    stroke: "#303826",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M262.388 93.7564C277.653 93.7564 290.028 81.4275 290.028 66.219C290.028 51.0106 277.653 38.6816 262.388 38.6816C247.123 38.6816 234.748 51.0106 234.748 66.219C234.748 81.4275 247.123 93.7564 262.388 93.7564Z",
    fill: "#F4FCBE",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M262.389 20V31.2043",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M262.389 103.092V114.296",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.85 33.8047L287.899 41.7376",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M236.876 92.5703L228.914 100.491",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M309.705 67.1543H298.459",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M226.305 67.1543H215.059",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M295.85 100.491L287.899 92.5703",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M236.876 41.7376L228.914 33.8047",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.453 284.065C34.453 284.065 28.8961 282.687 27.2363 283.238C25.5764 283.79 28.3428 285.755 28.3428 285.755C28.3428 285.755 26.9596 286.558 26.1297 288.499C25.2998 290.44 28.8961 289.601 28.8961 289.601C28.8961 289.601 27.8016 290.991 28.8961 292.094C29.9906 293.196 35.0062 287.672 35.0062 287.672C35.0062 287.672 38.6146 289.889 41.9463 289.613C45.278 289.338 47.2265 288.511 49.4396 285.192C51.6528 281.872 53.3246 280.219 53.3246 280.219L55.5498 279.392L52.2181 277.45C52.2181 277.45 49.4396 274.958 46.6612 275.234C43.8828 275.509 42.7762 276.336 42.7762 276.336C42.7762 276.336 41.1164 271.914 38.6146 270.249C36.1128 268.583 28.3428 266.378 25.841 264.988C23.3392 263.61 23.8925 265.815 24.7345 267.205C25.5764 268.595 28.0662 269.697 29.1727 270.249C30.2793 270.8 23.3392 271.075 24.4578 272.465C25.5764 273.855 29.738 274.407 29.738 274.407C29.738 274.407 25.8531 275.785 26.683 276.899C27.5129 278.002 30.8446 278.002 30.8446 278.002C30.8446 278.002 29.738 280.77 31.3979 280.77H33.0698C33.0698 280.77 32.2398 284.64 34.453 284.089V284.065Z",
    fill: "#F4FCBE",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7879 276.324C42.7879 276.324 45.0131 271.902 43.8945 269.134C42.788 266.366 32.5162 259.176 32.7928 261.944C33.0695 264.712 35.8479 266.366 35.8479 266.366C35.8479 266.366 31.6863 264.988 31.6863 266.091V267.193C31.6863 267.193 36.4012 268.295 38.6263 270.237C40.8515 272.178 42.7879 276.324 42.7879 276.324Z",
    fill: "#303826",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2834 279.296C48.825 279.296 48.4534 278.926 48.4534 278.469C48.4534 278.013 48.825 277.643 49.2834 277.643C49.7417 277.643 50.1133 278.013 50.1133 278.469C50.1133 278.926 49.7417 279.296 49.2834 279.296Z",
    fill: "#303826"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9852 287.543C38.4904 289.221 41.1366 289.916 43.903 289.101C46.6694 288.286 48.5096 286.261 48.0044 284.583C47.4993 282.906 44.8531 282.211 42.0867 283.026C39.3203 283.84 37.4801 285.866 37.9852 287.543Z",
    fill: "white",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M406.996 205.575C406.996 205.575 412.553 204.197 414.213 204.748C415.872 205.299 413.106 207.265 413.106 207.265C413.106 207.265 414.489 208.067 415.319 210.009C416.149 211.95 412.553 211.111 412.553 211.111C412.553 211.111 413.647 212.501 412.553 213.604C411.446 214.706 406.443 209.182 406.443 209.182C406.443 209.182 402.834 211.399 399.503 211.123C396.171 210.848 394.222 210.021 392.009 206.701C389.796 203.382 388.124 201.728 388.124 201.728L385.899 200.901L389.231 198.96C389.231 198.96 392.009 196.468 394.788 196.743C397.566 197.019 398.673 197.846 398.673 197.846C398.673 197.846 400.332 193.424 402.834 191.758C405.336 190.093 413.106 187.888 415.608 186.498C418.11 185.12 417.556 187.325 416.714 188.715C415.884 190.093 413.383 191.207 412.276 191.758C411.17 192.31 418.11 192.585 416.991 193.975C415.884 195.353 411.711 195.916 411.711 195.916C411.711 195.916 415.596 197.295 414.766 198.409C413.936 199.523 410.604 199.511 410.604 199.511C410.604 199.511 411.711 202.28 410.051 202.28H408.391C408.391 202.28 409.221 206.15 407.008 205.599L406.996 205.575Z",
    fill: "#F4FCBE",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M398.659 197.822C398.659 197.822 396.434 193.4 397.552 190.632C398.659 187.864 408.931 180.674 408.654 183.442C408.378 186.211 405.599 187.864 405.599 187.864C405.599 187.864 409.761 186.486 409.761 187.589V188.691C409.761 188.691 405.046 189.793 402.821 191.735C400.596 193.676 398.659 197.822 398.659 197.822Z",
    fill: "#303826",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M392.995 199.979C392.995 200.435 392.622 200.806 392.165 200.806C391.708 200.806 391.335 200.435 391.335 199.979C391.335 199.524 391.708 199.152 392.165 199.152C392.622 199.152 392.995 199.524 392.995 199.979Z",
    fill: "#303826"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M403.424 209.197C402.919 210.874 400.273 211.569 397.507 210.754C394.74 209.94 392.9 207.914 393.405 206.237C393.91 204.559 396.556 203.864 399.323 204.679C402.089 205.494 403.93 207.519 403.424 209.197Z",
    fill: "white",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M398.761 131.797C398.761 131.797 393.455 110.106 362.513 105.772C331.572 101.437 327.145 127.462 320.958 130.934C314.772 134.405 311.234 124.864 301.51 125.727C291.786 126.59 286.479 134.405 282.062 137.876C277.645 141.348 269.679 130.934 263.493 132.669C257.307 134.405 252 143.083 252 143.083H431.482C431.482 143.083 425.296 133.542 416.451 130.071C407.606 126.6 404.068 131.807 398.772 131.807L398.761 131.797Z",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M111.105 162.122C111.105 162.122 107.293 146.552 85.0411 143.432C62.7989 140.322 59.6157 159.002 55.1652 161.496C50.7148 163.99 48.1702 157.134 41.1853 157.76C34.1903 158.386 30.3785 163.99 27.2054 166.484C24.0323 168.979 18.3045 161.496 13.854 162.748C9.40358 164 5.5918 170.221 5.5918 170.221H134.625C134.625 170.221 130.174 163.364 123.818 160.88C117.461 158.386 114.917 162.122 111.105 162.122Z",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M161.302 64.2181C161.302 64.2181 158.868 54.2126 144.645 52.2075C130.432 50.2023 128.398 62.2129 125.555 63.815C122.712 65.4171 121.087 61.0139 116.618 61.4169C112.15 61.82 109.716 65.4171 107.682 67.0192C105.647 68.6213 101.997 63.815 99.154 64.6211C96.3115 65.4272 93.8779 69.4274 93.8779 69.4274H176.343C176.343 69.4274 173.5 65.0241 169.441 63.4221C165.381 61.82 163.756 64.2181 161.312 64.2181H161.302Z",
    stroke: "#303826",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIllustration);
export default __webpack_public_path__ + "static/media/property_illustration.99285207816321a098d9b0d6f3dc384e.svg";
export { ForwardRef as ReactComponent };